import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { NbAuthService } from '@nebular/auth';
import { tap } from 'rxjs/operators';

@Injectable()
export class PermissionGuard implements CanActivate {

    constructor(private authService: NbAuthService, private router: Router) {
    }
    canActivate() {
        if (window.location.href.indexOf('auth/login') > 0) {
            return this.authService.isAuthenticated().pipe(
                tap((authenticated: boolean) => {
                    if (!authenticated) {
                        localStorage.clear();
                        if (window.location.href.indexOf('auth/login') === -1) {
                            this.router.navigate(['auth/login']);

                        }
                        // 
                    } else {
                        this.router.navigate(['/']);
                    }
                }),
            );
        } else {
            return true;
        }
    }
}
